import {
  isMobile,
  getProductDiscount,
  validateTrackerModalOnBlur,
  validateTrackerModal,
  redirectToTracker,
} from '../utils';
import store from '../store';
import {
  FETCH_CATEGORIES,
  FETCH_PLANS,
  ADD_COMPARISON_PLAN,
  REMOVE_COMPARISON_PLAN,
  CLEAN_COMPARISON_PLANS,
  SET_PROVIDER_OPTION,
  SET_SORT_OPTIONS,
  SET_SORT_OPTION,
  FILTER_PLANS,
  SET_QUOTATION_PARAMS,
  FETCH_DISCOUNT_COUPON,
  SET_USER_DETAILS,
  FILTER_PLANS_MOBILE,
  OPEN_MODAL_QUOTATION_DATE_WARNING,
  CLOSE_MODAL_QUOTATION_DATE_WARNING,
  OPEN_MODAL_FILTER_CATEGORY,
  CLOSE_MODAL_FILTER_CATEGORY,
  GET_INFOS_PROSPECT,
  OPEN_MODAL_QUOTATION_DATE_YEAR,
  CLOSE_MODAL_QUOTATION_DATE_YEAR,
  OPEN_MODAL_WITHOUT_TRACKER,
  CLOSE_MODAL_WITHOUT_TRACKER,
  SET_TRACKER_INFOS_PROSPECT,
  TRACKER_MODAL_VALIDATOR_HANDLER_BLUR,
  VALIDATE_TRACKER_MODAL_REDIRECT,
  APPLY_FILTER_CATEGORIES,
  CLEAR_FILTER_CATEGORIES,
  UNSELECT_FILTER_CATEGORY_OPTIONS,
  SEARCH_ECOMMERCE_SETTINGS,
  SEARCH_PROVIDER_SETTINGS,
  TOGGLE_SPECIALIST_SUGGESTION,
  STORE_HIGHLIGTH_PLANS,
  OPEN_MODAL_UPSELL,
  CLOSE_MODAL_UPSELL,
  SET_UPSELL_PLANS,
  SET_UPSELL_SOURCE_TAGS,
} from '../actions/actionTypes';
import { addPreventScrollStyle, removePreventScrollStyle } from '../utils/preventScroll';

let newState = {};

const orderPlansCategory = (items, renewalFirst = false, covidCoverage = false, specialistSuggestionsActive = false, promotionalDestination = false) => {
  const specialistSuggestions = [];
  const covid = [];
  const special = [];
  const renewal = [];
  const common = [];
  const promotional = [];
  const itemCheck = items[0] !== undefined && JSON.stringify(items[0]) !== JSON.stringify({});
  const orderingByPrice = (a, b) =>
    (a.price_with_coupon_discount || a.adult.price) - (b.price_with_coupon_discount || b.adult.price);

  if (items.length >= 1 && itemCheck) {
    for (let i = 0; i < items.length; i++) {
      if (promotionalDestination && items[i].extra.promotional_destination_product) {
        promotional.push(items[i]);
        continue;
      }

      if (items[i].extra.covid_coverage && items[i].extra.special !== true) {
        covid.push(items[i]);
        continue;
      }

      if (items[i].extra.travel_renewal !== 'no') {
        renewal.push(items[i]);
        continue;
      }

      if (specialistSuggestionsActive) {
        if (items[i].extra.special && items[i].extra.specialist_indicator !== true) {
          special.push(items[i]);
          continue;
        }

        if (items[i].extra.specialist_indicator) {
          specialistSuggestions.push(items[i]);
          continue;
        }
      } else {
        if (items[i].extra.special) {
          special.push(items[i]);
          continue;
        }
      }

      common.push(items[i]);
    }
  }

  promotional.sort((a, b) => orderingByPrice(a, b));
  specialistSuggestions.sort((a, b) => orderingByPrice(a, b));
  covid.sort((a, b) => orderingByPrice(a, b));
  special.sort((a, b) => orderingByPrice(a, b));
  renewal.sort((a, b) => orderingByPrice(a, b));
  common.sort((a, b) => orderingByPrice(a, b));

  if (renewalFirst) return [...promotional, ...renewal, ...special, ...specialistSuggestions, ...covid, ...common];
  else if (covidCoverage) return [...promotional, ...covid, ...special, ...specialistSuggestions, ...renewal, ...common];
  else if (specialistSuggestionsActive) return [...promotional, ...specialistSuggestions, ...special, ...renewal, ...covid, ...common];

  return [...promotional, ...special, ...specialistSuggestions, ...renewal, ...covid, ...common];
};

const orderPlansByFilter = (state) => {
  let optionSelected = null;
  let filteredPlans = [];

  let categorySelected = [];
  const providerSelected = [];

  const plansFiltered = [];
  let plans = [];

  // Verificando quais categorias estão selecionadas, e separando por tipo de categoria
  state.filterCategory.map((category) => {
    optionSelected = category.Categories.filter((option) => option.selected === true);
    if (optionSelected.length > 0)
      categorySelected = [...categorySelected, { ...category, plans: [], Categories: optionSelected }];
    return true;
  });

  // Inserindo planos pertecentes a cada categoria
  categorySelected.map((category, i) => {
    category.Categories.map((categorie) => {
      state.plans.map((plan) => {
        if (plan.categories) {
          const categoryPlanFiltered = plan.categories.filter((opt) => opt.ID === categorie.ID);
          if (categoryPlanFiltered.length > 0) {
            categorySelected[i].plans.push(plan);
          }
        }
      });
    });
  });

  // Verificando de o plano está em todos tipos de categoria que foram selecionados
  categorySelected.map((category, i) => {
    category.plans.map((plan) => {
      const validationCategories = [];

      for (let x = 0; x < categorySelected.length; x++) {
        if (x !== i) {
          if (categorySelected[x].plans.some((opt) => opt.code === plan.code)) {
            validationCategories.push(plan);
          }
        }
      }

      if (
        validationCategories.length === categorySelected.length - 1 &&
        !plans.some((opt1) => opt1.code === plan.code)
      ) {
        plans.push(plan);
      }
    });
  });

  optionSelected = state.filterProvider.filter((provider) => provider.selected === true);
  if (optionSelected.length > 0) providerSelected.push(...optionSelected);

  const plansList = plans.length > 0 ? plans : state.plans;

  const disabledProviders = state.ecommerce_settings.disabled_providers;

  // FILTRA O PLANOS POR SEGURADORA
  providerSelected.map((provider) => {
    filteredPlans = plansList.filter((p) => p.provider_code === provider.code);
    plansFiltered.push(...filteredPlans);
    return true;
  });
  if (categorySelected.length === 0 && providerSelected.length === 0) {
    const removeDisabledProviders = plansList.filter((p) => !disabledProviders.includes(p.provider_code)); // Remove os provedores desabilitados
    plans.push(...removeDisabledProviders);
    // VERIFICA SE NAO HÁ CATEGORIA E SEGURADORA SELECIONADA NO FILTRO, DEVOLVENDO O DEFAULT DOS PLANOS NA PESQUISA
  } else if (providerSelected.length !== 0) {
    plans = plansFiltered;
  }

  // REFAZ O STATE PARA DEVOLVER SUGESTAO CASO NAO ENCONTRE PLANOS DEPOIS SELECIONAR OS FILTROS
  const oldState = sortPlansByOrder(
    calcCouponDiscount({
      ...state,
      filtered_plans: state.plans,
    })
  );

  return {
    ...state,
    filtered_plans: plans,
    suggestions_plans: oldState.filtered_plans,
  };
};

const calcCouponDiscount = (state) => {
  const rootState = store.getState();

  let pixDiscountPercentage = 5;
  if (rootState.purchase && rootState.purchase.paymentMethods) {
    const pixPayment = rootState.purchase.paymentMethods.find(method => method.slug === 'pix');
    if (pixPayment && pixPayment.discount) {
      pixDiscountPercentage = pixPayment.discount;
    }
  }

  const filteredPlans = state.filtered_plans.map((plan) => {
    if (plan) {
      const priceWithPixDiscount = plan.adult.price - (plan.adult.price / 100) * pixDiscountPercentage;
      const priceWithCouponDiscount = plan ? getProductDiscount(plan.adult.price, plan.code, state.coupon) : 0;
      return {
        ...plan,
        price_with_coupon_discount: priceWithCouponDiscount,
        price_with_discount: priceWithCouponDiscount
          ? plan
            ? getProductDiscount(priceWithPixDiscount, plan.code, state.coupon)
            : 0
          : priceWithPixDiscount,
      };
    }
    return {};
  });

  const plans = state.plans.map((plan) => {
    if (plan) {
      const priceWithPixDiscount = plan.adult.price - (plan.adult.price / 100) * pixDiscountPercentage;
      const priceWithCouponDiscount = plan ? getProductDiscount(plan.adult.price, plan.code, state.coupon) : 0;

      return {
        ...plan,
        price_with_coupon_discount: priceWithCouponDiscount,
        price_with_discount: priceWithCouponDiscount
          ? plan
            ? getProductDiscount(priceWithPixDiscount, plan.code, state.coupon)
            : 0
          : priceWithPixDiscount,
      };
    }
    return {};
  });

  return {
    ...state,
    plans,
    filtered_plans: filteredPlans,
  };
};

const sortPlansByOrder = (state) => {
  const rootState = store.getState();
  const globalState = rootState.global;

  const LOWER_PRICE = state.sortOptions[0].name;
  const SPECIAL_PRICE = state.sortOptions[1].name;
  const HIGH_PRICE = state.sortOptions[2].name;
  const COVID_COVERAGE = state.sortOptions[3].name;

  const destinations = globalState.destinations || [];
  const PROMOTIONAL_DESTINATION = (destinations.filter((item) => item.slug === state.destination)[0] || {}).promotional;

  if (state.showSpecialistSuggestions) {
    const specialistSuggestions = state.filtered_plans.filter((plan) => plan.extra.specialist_indicator);
    const others = state.filtered_plans.filter((plan) => !plan.extra.specialist_indicator);

    if (state.sort_option === LOWER_PRICE) {
      return {
        ...state,
        filtered_plans: [specialistSuggestions.sort((a, b) => (a.price_with_coupon_discount || a.adult.price) - (b.price_with_coupon_discount || b.adult.price)),
        others.sort((a, b) => (a.price_with_coupon_discount || a.adult.price) - (b.price_with_coupon_discount || b.adult.price))].flat(),
      }
    }

    if (state.sort_option === HIGH_PRICE) {
      return {
        ...state,
        filtered_plans: [specialistSuggestions.sort((a, b) => (b.price_with_coupon_discount || b.adult.price) - (a.price_with_coupon_discount || a.adult.price)),
        others.sort((a, b) => (b.price_with_coupon_discount || b.adult.price) - (a.price_with_coupon_discount || a.adult.price))].flat(),
      }
    }

    return {
      ...state,
      filtered_plans: orderPlansCategory([...state.filtered_plans], false, false, true, PROMOTIONAL_DESTINATION),
    };
  }

  if (state.sort_option === LOWER_PRICE)
    return {
      ...state,
      filtered_plans: [...state.filtered_plans].sort(
        (a, b) => (a.price_with_coupon_discount || a.adult.price) - (b.price_with_coupon_discount || b.adult.price)
      ),
    };
  else if (state.sort_option === SPECIAL_PRICE) {
    return {
      ...state,
      filtered_plans: orderPlansCategory([...state.filtered_plans], false, false, false, PROMOTIONAL_DESTINATION),
    };
  } else if (state.sort_option === HIGH_PRICE) {
    return {
      ...state,
      filtered_plans: [...state.filtered_plans].sort(
        (a, b) => (b.price_with_coupon_discount || b.adult.price) - (a.price_with_coupon_discount || a.adult.price)
      ),
    };
  } else if (state.sort_option === COVID_COVERAGE) {
    return {
      ...state,
      filtered_plans: orderPlansCategory([...state.filtered_plans], false, true, false, PROMOTIONAL_DESTINATION),
    };
  }
  return {
    ...state,
    filtered_plans: state.plans,
  };
};

export const search = (state = {}, action) => {
  switch (action.type) {
    case SEARCH_ECOMMERCE_SETTINGS:
      return {
        ...state,
        ecommerce_settings: action.settings,
      };
    case SEARCH_PROVIDER_SETTINGS:
      return {
        ...state,
        providers: action.settings,
        filterProvider: [
          ...action.settings.map((provider) => ({
            ...provider,
            selected: false,
          })),
        ],
      };
    case FETCH_DISCOUNT_COUPON:
      newState = {
        ...state,
        coupon: action.coupon,
      };
      return sortPlansByOrder(calcCouponDiscount(orderPlansByFilter(newState)));

    case ADD_COMPARISON_PLAN:
      if (isMobile() && state.comparisonPlans.length >= 2) return { ...state };
      if (state.comparisonPlans.length >= 4) return { ...state };

      return {
        ...state,
        comparisonPlans: state.comparisonPlans.concat(action.plan),
      };

    case REMOVE_COMPARISON_PLAN:
      return {
        ...state,
        comparisonPlans: state.comparisonPlans.filter((item) => item.code !== action.planCode),
      };

    case CLEAN_COMPARISON_PLANS:
      return {
        ...state,
        comparisonPlans: [],
      };

    case FETCH_CATEGORIES:
      const { categoryUrl, providerUrl } = action.params;
      newState = {
        ...state,
        filterProvider: [
          ...state.providers.map((provider) => ({
            ...provider,
            selected: providerUrl.some((providerOption) => providerOption === provider.slug),
          })),
        ],
        filterCategory: [
          ...action.category.map((category) => ({
            ...category,
            Categories: category.Categories
              ? category.Categories.map((subCategory) => ({
                ...subCategory,
                selected: categoryUrl.some((categoryOption) => Number(categoryOption) === subCategory.ID),
              }))
              : [],
          })),
        ],

      };

      return sortPlansByOrder(calcCouponDiscount(orderPlansByFilter(newState)));
    case FETCH_PLANS:
      newState = {
        ...state,
        loading: false,
        plans: action.plans,
        filtered_plans: action.plans,
      };
      return sortPlansByOrder(calcCouponDiscount(orderPlansByFilter(newState)));
    case FILTER_PLANS:
      return sortPlansByOrder(calcCouponDiscount(state));
    case SET_PROVIDER_OPTION:
      return {
        ...state,
        provider_option: action.provider_option,
      };
    case SET_SORT_OPTIONS:
      newState = {
        ...state,
        sortOptions: action.sortOptions,
      }
      return sortPlansByOrder(calcCouponDiscount(orderPlansByFilter(newState)));
    case SET_SORT_OPTION:
      newState = {
        ...state,
        sort_option: action.sort_option,
        showSpecialistSuggestions: false,
      };
      return sortPlansByOrder(calcCouponDiscount(orderPlansByFilter(newState)));
    case SET_QUOTATION_PARAMS:
      return {
        ...state,
        loading: true,
        begin_date: action.begin_date,
        end_date: action.end_date,
        destination: action.destination,
        queryParams: action.queryParams,
      };
    case SET_USER_DETAILS:
      return {
        ...state,
        userDetails: action.userDetails,
      };
    case FILTER_PLANS_MOBILE:
      return {
        ...state,
        searchState: !state.searchState,
      };
    case OPEN_MODAL_QUOTATION_DATE_WARNING:
      return {
        ...state,
        isModalQuotationDateWarningActive: true,
      };
    case CLOSE_MODAL_QUOTATION_DATE_WARNING:
      return {
        ...state,
        isModalQuotationDateWarningActive: false,
      };
    case OPEN_MODAL_FILTER_CATEGORY:
      addPreventScrollStyle();
      return {
        ...state,
        isModalFilterCategoryActive: true,
      };
    case CLOSE_MODAL_FILTER_CATEGORY:
      removePreventScrollStyle();
      return {
        ...state,
        isModalFilterCategoryActive: false,
      };
    case GET_INFOS_PROSPECT:
      if (action.infos) {
        return {
          ...state,
          prospect: action.infos,
        };
      }
      return state;
    case OPEN_MODAL_QUOTATION_DATE_YEAR:
      return {
        ...state,
        isModalQuotationDateYearActive: true,
      };
    case CLOSE_MODAL_QUOTATION_DATE_YEAR:
      return {
        ...state,
        isModalQuotationDateYearActive: false,
      };
    case OPEN_MODAL_WITHOUT_TRACKER:
      return {
        ...state,
        isModalWithoutTrackerActive: true,
      };
    case CLOSE_MODAL_WITHOUT_TRACKER:
      return {
        ...state,
        isModalWithoutTrackerActive: false,
      };
    case SET_TRACKER_INFOS_PROSPECT:
      const checkModalFill = validateTrackerModal(action.prospect);

      return {
        ...state,
        modalProspect: action.prospect,
        modalProspectAvaliable: checkModalFill.isValid,
      };
    case TRACKER_MODAL_VALIDATOR_HANDLER_BLUR:
      const error = validateTrackerModalOnBlur(state.modalProspect, action.key);

      return {
        ...state,
        modalProspect: {
          ...state.modalProspect,
          errors: {
            ...state.modalProspect.errors,
            [action.key]: error,
          },
        },
      };
    case VALIDATE_TRACKER_MODAL_REDIRECT:
      const errors = validateTrackerModal(state.modalProspect);
      if (errors.isValid)
        redirectToTracker(
          action.destination,
          action.begin_date,
          action.end_date,
          state.modalProspect,
          action.couponModal
        );
      return {
        ...state,
        modalProspect: {
          ...state.modalProspect,
          errors,
        },
      };
    case APPLY_FILTER_CATEGORIES:
      removePreventScrollStyle();
      return sortPlansByOrder(
        calcCouponDiscount(
          orderPlansByFilter({
            ...state,
            isModalFilterCategoryActive: false,
          })
        )
      );
    case CLEAR_FILTER_CATEGORIES:
      newState = {
        ...state,
        filterProvider: [
          ...state.providers.map((provider) => ({
            ...provider,
            selected: false,
          })),
        ],
        filterCategory: [
          ...state.filterCategory.map((category) => ({
            ...category,
            Categories: category.Categories.map((subCategory) => ({
              ...subCategory,
              selected: false,
            })),
          })),
        ],
      };
      return sortPlansByOrder(calcCouponDiscount(orderPlansByFilter(newState)));
    case UNSELECT_FILTER_CATEGORY_OPTIONS:
      const { type_category, category_index, option_index } = action;
      const { filterCategory, filterProvider } = state;

      if (type_category === 'provider') {
        filterProvider[category_index].selected = !filterProvider[category_index].selected;
        return sortPlansByOrder(
          calcCouponDiscount(
            orderPlansByFilter({
              ...state,
              filterProvider: [...filterProvider],
            })
          )
        );
      } else if (type_category === 'category') {
        filterCategory[category_index].Categories[option_index].selected =
          !filterCategory[category_index].Categories[option_index].selected;
        return sortPlansByOrder(
          calcCouponDiscount(
            orderPlansByFilter({
              ...state,
              filterCategory: [...filterCategory],
            })
          )
        );
      }
      return {};
    case STORE_HIGHLIGTH_PLANS:
      return {
        ...state,
        highlightPlans: action.plans,
      };
    case TOGGLE_SPECIALIST_SUGGESTION:
      newState = {
        ...state,
        showSpecialistSuggestions: !state.showSpecialistSuggestions,
      };
      return sortPlansByOrder(calcCouponDiscount(orderPlansByFilter(newState)));
    case OPEN_MODAL_UPSELL:
      return {
        ...state,
        isModalUpsellActive: true,
      };
    case CLOSE_MODAL_UPSELL:
      return {
        ...state,
        isModalUpsellActive: false,
        upsellSourceTags: [],
      };
    case SET_UPSELL_PLANS:
      return {
        ...state,
        upsellPlans: action.plans,
      };
    case SET_UPSELL_SOURCE_TAGS:
      return {
        ...state,
        upsellSourceTags: action.tags,
      };
    default:
      return state;
  }
};

export default search;



// WEBPACK FOOTER //
// ./src/reducers/searchReducer.js